<template>
  <LayoutBaseContent class="max-w-7xl">
    <LayoutPanel>
      <div class="container-padding">
        <h1 class="font-medium text-3xl">Sitemap</h1>

        <div class="flex flex-wrap items-center mt-4">
          <UtilButton
            v-for="commodity in topLevelCommodities"
            :key="commodity.slug"
            :to="`/sitemap/${commodity.slug}`"
            :color="activeCommodity === commodity.slug ? 'primary' : 'secondary'"
            :small="$breakpoint.xs"
            class="mr-2"
          >
            {{ commodity.name }}
          </UtilButton>
        </div>

        <UtilDivider class="mt-6 mb-4" />

        <h1 class="font-medium text-lg">Countries</h1>

        <UtilLoader :isLoading="countryApi.loading" class="mt-4">
          <div class="sitemap-columns">
            <UtilTextLink
              v-for="country in countryApi.data"
              :key="country.countryId"
              :to="`/${activeCommodity}/geo/${kebabCase(country.name)}`"
              class="text-brand"
            >
              {{ country.name }}
            </UtilTextLink>
          </div>
        </UtilLoader>

        <UtilDivider class="mt-6 mb-4" />

        <h1 class="font-medium text-lg">Counties</h1>

        <UtilLoader :isLoading="regionApi.loading" class="mt-4">
          <div class="sitemap-columns">
            <UtilTextLink
              v-for="region in regionApi.data"
              :key="region.region"
              :to="`/${activeCommodity}/geo/united-kingdom/${kebabCase(region.region)}`"
              class="text-brand"
            >
              {{ region.region }}
            </UtilTextLink>
          </div>
        </UtilLoader>

        <UtilDivider class="mt-6 mb-4" />

        <template v-if="popularTagsApi.data.length > 0 || popularTagsApi.loading">
          <h1 class="font-medium text-lg">
            Popular
          </h1>

          <UtilLoader :isLoading="popularTagsApi.loading" class="mt-4">
            <div class="sitemap-columns">
              <UtilTextLink
                v-for="tag in popularTagsApi.data"
                :key="tag.presetSlug"
                :to="`/${activeCommodity}/popular/${tag.presetSlug}`"
                class="text-brand"
              >
                {{ tag.name }}
              </UtilTextLink>
            </div>
          </UtilLoader>

          <UtilDivider class="mt-6 mb-4" />
        </template>

        <h1 class="font-medium text-lg">Categories</h1>

        <UtilLoader :isLoading="categoriesApi.loading" class="mt-4">
          <div class="sitemap-columns">
            <UtilTextLink
              v-for="category in categoriesApi.data"
              :key="category.categoryRef"
              :to="
                category.parentSlug
                  ? `/${activeCommodity}/category/${category.parentSlug}/${category.slug}`
                  : `/${activeCommodity}/category/${category.slug}`
              "
              class="text-brand"
            >
              {{ category.name }}
            </UtilTextLink>
          </div>
        </UtilLoader>
      </div>
    </LayoutPanel>
  </LayoutBaseContent>
</template>

<script>
import { kebabCase } from 'lodash'
import { topLevelCommodities } from '@/lib/helpers/commodities'
import LayoutBaseContent from '@/components/layout/LayoutBaseContent'
import LayoutPanel from '@/components/layout/LayoutPanel'
import UtilButton from '@/components/utils/UtilButton'
import UtilTextLink from '@/components/utils/UtilTextLink'
import UtilDivider from '@/components/utils/UtilDivider'
import UtilLoader from '@/components/utils/UtilLoader'
import LegacyApi from '@/lib/api/legacy'

export default {
  name: 'Sitemap',
  components: {
    LayoutBaseContent,
    LayoutPanel,
    UtilButton,
    UtilTextLink,
    UtilDivider,
    UtilLoader
  },
  data() {
    return {
      countryApi: new LegacyApi(),
      regionApi: new LegacyApi(),
      popularTagsApi: new LegacyApi(),
      categoriesApi: new LegacyApi(),
      activeCommodity: 'livestock',
      topLevelCommodities,
      kebabCase
    }
  },
  watch: {
    '$route.params'() {
      this.setup()
    }
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      if (this.$route.params.commodity) {
        this.activeCommodity = this.$route.params.commodity
      }

      this.getGeo()
      this.getPopularTags()
      this.getCategories()
    },

    getGeo() {
      this.countryApi.get('countries.get')
      this.regionApi.get('regions.get')
    },

    getPopularTags() {
      this.popularTagsApi.get('listings.searchpresets', {
        commodity: this.activeCommodity
      })
    },

    getCategories() {
      this.categoriesApi.get('categories.flat', {
        commodity: this.activeCommodity
      })
    }
  },
  head: {
    title() {
      return {
        inner: 'Sitemap'
      }
    }
  }
}
</script>

<style lang="scss">
.sitemap-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, 19%);
  grid-gap: 1.5rem 1%;
}

#app.smAndDown {
  .sitemap-columns {
    grid-template-columns: repeat(auto-fit, 30%);
  }
}
</style>
